module.exports = __webpack_public_path__ + "static/media/9.959923c3.jpg";